export default "__VITE_ASSET__DOJVUiOC__"